import { render, staticRenderFns } from "./abandonfile.vue?vue&type=template&id=2a626f12&scoped=true&"
import script from "./abandonfile.vue?vue&type=script&lang=js&"
export * from "./abandonfile.vue?vue&type=script&lang=js&"
import style0 from "./abandonfile.vue?vue&type=style&index=0&id=2a626f12&lang=less&scoped=true&"
import style1 from "./abandonfile.vue?vue&type=style&index=1&id=2a626f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a626f12",
  null
  
)

export default component.exports